module.exports = __webpack_public_path__ + "resources/img/img_sw_jp.73a72ceee3167732e774ca519a46e8c0.png";